// var $ = require('jquery');
var $ = window.jQuery;

module.exports = $;
